import React, {useEffect} from 'react';
import {Routes, Route, useLocation} from 'react-router-dom';
import './App.scss';
import LayoutEntry from './component/layout/entry/Entry';
import Layout from './component/layout/Layout';
import Modal from './component/modal/Modal';

function App() {
    let location = useLocation();

    // correct path for routing
    if (location.pathname.includes('/show/')) {
        location.pathname = '/show/' + location.pathname.split('/show/')[1];
    } else {
        location.state = null;
    }

    // The `backgroundLocation` state is the location that we were at when one of
    // the gallery links was clicked. If it's there, use it as the location for
    // the <Routes> so we show the gallery in the background, behind the modal.
    let state = location.state as { backgroundLocation? : Location };

    useEffect(() => {
        if (location.pathname.includes('/show/')) {
            document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        } else {
            document.getElementsByTagName('html')[0].style.overflow = 'visible';
        }
    }, [location]);

    return (
        <div className="App">
            {/* Show the modal when a `backgroundLocation` is set */}
            {state?.backgroundLocation ? (
                <Routes>
                    <Route path="/show/:translationPath" element={<Modal/>}/>
                </Routes>
            ) : (
                <Routes location={state?.backgroundLocation || location}>
                    <Route path="/" element={<Layout/>}>
                        <Route index element={<LayoutEntry/>}/>
                        <Route path="/show/:translationPath" element={<Modal/>}/>
                        <Route path="*" element={<LayoutEntry/>}/>
                    </Route>
                </Routes>
            )}
        </div>
    );
}

export default App;
